// extracted by mini-css-extract-plugin
module.exports = {"miscSettingsWrapper":"MiscSettings_miscSettingsWrapper__7vwzY"};